"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (state, props) {
  var linkName = props.linkName;
  var _props$trackingCode = props.trackingCode;
  var trackingCode = _props$trackingCode === undefined ? null : _props$trackingCode;


  return _extends({}, state, {
    linkName: linkName,
    trackingCode: trackingCode
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/reducers/link.js
 ** module id = 443
 ** module chunks = 0
 **/